import {VisionScenario} from './VisionScenario';

export class VisionStepScenario extends VisionScenario {}

